import { EMAIL_SERVER_AXIOS } from "../../config";

export const sendApplyEmail = async (payload) => {
  try {
    const data = await EMAIL_SERVER_AXIOS.post("/email/apply-to-join", payload);
    return data
  } catch (error) {
    return {
      data:error?.response?.data
    }
  }
};

export const sendContactEmail = async (payload) => {
  try {
    const data = await EMAIL_SERVER_AXIOS.post("/email/contact-us", payload);
    return data
  } catch (error) {
    return {
      data:error?.response?.data
    }
  }
};